// Initialize browser monitoring before evaluating any other modules (see the module for details):
// eslint-disable-next-line simple-import-sort/imports
import './initBrowserMonitoring';

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

import '@sato/components/lib/index.css';
import './index.css';
import './giosg.css';

const rootElement = document.getElementById('app');

if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

const renderApp = () =>
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );

renderApp();

if (module.hot) {
  module.hot.accept('./App.tsx', function () {
    console.log('Hot module update...');
    renderApp();
  });
}
